import { Fetcher } from 'swr'
import api from './api'
import { IUserReport, IUserScan } from 'models/user.model'

const getScan = async () => api.get<IUserScan>(`/v1/user/scan`).then(res => res.data)

const updateLanguage = async (language: string) =>
  api.put(`/v1/register/language`, { language }).then(res => res.data)

const newScan = async (params: { cognitoId: string }): Promise<string> =>
  api.post(`/v2/user/${params.cognitoId}/scan`).then(res => res.data)

const getAllUserReports = async cognitoId =>
  api.get<IUserReport[]>(`/v2/user/${cognitoId}/user-report`).then(res => res.data)

const getUserReportsbyType = async (cognitoId, leakType) =>
  api.get<IUserReport[]>(`/v2/user/${cognitoId}/user-report/${leakType}`).then(res => res.data)

const createUserReport = async (params: Omit<IUserReport, 'id' | 'createdAt'>, cognitoId) =>
  api.post(`/v2/user/${cognitoId}/user-report/`, params).then(res => res.data)

const deleteOneUserByCognitoId = async cognitoId =>
  api.delete(`/v2/user/${cognitoId}`).then(res => res.data)

type ModulesData = {
  isCyberMatchModuleEnabled?: boolean
}
export const userModulesFetcher: Fetcher<ModulesData, string> = () =>
  api.get(`/v1/register/modules`).then(response => response.data)

export default {
  getScan,
  updateLanguage,
  newScan,
  getAllUserReports,
  createUserReport,
  getUserReportsbyType,
  deleteOneUserByCognitoId,
  userModulesFetcher,
}
